import {
  sub as fnsSub,
  format as fnsFormat,
  getYear as fnsGetYear,
  isAfter as fnsIsAfter,
  isBefore as fnsIsBefore,
  fromUnixTime as fnsFromUnixTime,
  differenceInDays as fnsDifferenceInDays,
  parseISO as fnsParseISO,
  isValid as fnsIsValid,
} from "date-fns/esm";

// Date time format
export const DATETIME_12HR_FORMAT = "MMM dd, yy - p";

// Date formats
export const DATE_FORMAT = "MMM dd, yyyy";
export const MONTH_YEAR_FORMAT = "MMM yyyy";
export const FULL_MONTH_YEAR_FORMAT = "MMMM dd, yyyy";
export const FULL_MONTH_AND_ONLY_YEAR_FORMAT = "MMMM yyyy";
export const MONTH_DATE_YEAR_FORMAT = "MM/dd/yy";
export const MONTH_DATE_FULL_YEAR_FORMAT = "MM/dd/yyyy";
export const MONTH_DATE_YEAR_TIME_FORMAT = "MM/dd/yyyy hh:mm aaaaa'm'";
export const YEAR_FORMAT = "yyyy";
export const TIME_FORMAT = `hh:mm:ss aaaaa'm'`;
export const TIME_FORMAT_NO_SEC = "hh:mm a";
export const DATE_ISO_FORMAT = "yyyy-MM-dd'T'HH:mm:ss'Z'";
export const DATE_TIME_FORMAT = `${DATE_FORMAT} ${TIME_FORMAT_NO_SEC}`;

// Time formats
export const TIME_12HR_FORMAT = "hh:mm A";

export const unixToDateTime = (date, format = DATETIME_12HR_FORMAT) => {
  try {
    if (date && new Date(date) instanceof Date && !isNaN(date)) {
      return fnsFormat(fnsFromUnixTime(date), format);
    }
    return null;
  } catch (error) {
    console.error("unixToDateTime: ", error.message);
  }
};

export const convertTimestampToDate = (value, timeframe, format) => {
  if (!value) {
    return "";
  }
  if (timeframe === "1d") {
    return unixToDateTime(value, TIME_12HR_FORMAT);
  } else if (format) {
    return unixToDateTime(value, format);
  } else {
    return unixToDateTime(value, DATE_FORMAT);
  }
};

export const format = (format = DATETIME_12HR_FORMAT, date = new Date()) => {
  return fnsFormat(date, format);
};

export const sub = (duration, date = new Date()) => {
  return fnsSub(date, duration);
};

export const getYear = (date = new Date()) => {
  return fnsGetYear(date);
};

export const momentToFormat = (momentObject, format = "X") => {
  return momentObject.format(format);
};

export const momentToDate = (momentObject) => {
  return momentObject.toDate();
};

export const unixSecToMillisec = (date) => {
  if (date && new Date(date) instanceof Date && !isNaN(date)) {
    return date * 1000;
  }
};

export const getTimeStampInSeconds = () => {
  return new Date().getTime();
};

export const differenceInDays = fnsDifferenceInDays;
export const fromUnixTime = fnsFromUnixTime;
export const isAfter = fnsIsAfter;
export const isBefore = fnsIsBefore;

/**
 * Parses a date string into a Date object.
 * Tries parseISO first, then falls back to new Date() if that fails.
 * @param {string} dateString - The date string to parse
 * @returns {Date|null} - The parsed Date object or null if invalid
 */
export const parseDateISO = (dateString) => {
  if (!dateString) return null;
  let date = fnsParseISO(dateString);
  if (!fnsIsValid(date)) date = new Date(dateString);
  return fnsIsValid(date) ? date : null;
};

/**
 * Formats a date string with ordinal suffix (e.g., "May 5th, 14:26").
 * @param {string} dateString - The date string to format
 * @returns {string} - The formatted date string or empty string if invalid
 */
export const formatDateSuffix = (dateString) => {
  const date = parseDateISO(dateString);
  if (!date) return "";

  // Format: "May 5th, 14:26" or "May 6th, 09:12"
  const day = fnsFormat(date, "d");
  const daySuffix =
    day === "1" || day === "21" || day === "31"
      ? "st"
      : day === "2" || day === "22"
      ? "nd"
      : day === "3" || day === "23"
      ? "rd"
      : "th";
  const monthAndDay = fnsFormat(date, "MMMM d");
  const time = fnsFormat(date, "HH:mm");

  return `${monthAndDay}${daySuffix}, ${time}`;
};
